import { LitElement, html, css } from 'lit';

class DashboardModalWindow extends LitElement {
    static get styles() {
        return css`
        :host {
            position: fixed;
            z-index: 2000;
        }
        /* モーダルウィンドウの背景 */
        .modal-backdrop {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            visibility: hidden; /* 初期状態では見えないように */
            opacity: 0;
            transition: visibility 0s, opacity 0.3s;
        }
        
        /* モーダルウィンドウがアクティブな時のスタイル */
        .modal-backdrop.active {
            visibility: visible;
            opacity: 1;
        }
        
        /* モーダルウィンドウ */
        .modal {
            background-color: #fff;
            padding: 20px;
            border-radius: 8px;
            width: 90%;
            max-width: 500px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        
        .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .modal-header h2 {
            margin: 0;
        }
        
        .close-button {
            cursor: pointer;
            font-size: 24px;
        }
        
        .modal-body {
            margin-top: 20px;
        }
        
        .form-group {
            display: flex;
            margin-bottom: 10px;
        }
        
        .form-group label {
            display: block;
            margin-bottom: 5px;
        }
        
        .form-group input,
        .form-group textarea {
            width: 100%;
            padding: 10px;
            border-radius: 4px;
            border: 1px solid #ddd;
        }
        
        .form-actions {
            margin-top: 20px;
            text-align: right;
            display: flex;
            justify-content: space-evenly;
        }
        
        .submit-button,
        .cancel-button {
            padding: 10px 20px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.2s;
        }
        
        /*
        .submit-button {
            background-color: #007bff;
            color: white;
        }
        
        .cancel-button {
            background-color: #f8f9fa;
        }
        
        .submit-button:hover {
            background-color: #0056b3;
        }
        
        .cancel-button:hover {
            background-color: #e2e6ea;
        }
        */

        .submit-button {
            background-color: var(--submit-button-bg-color, #007bff);
            color: var(--submit-button-color, white);
        }

        .cancel-button {
            background-color: var(--cancel-button-bg-color, #f8f9fa);
            color: var(--cancel-button-color, black); 
        }

        .submit-button:hover {
            background-color: var(--submit-button-hover-bg-color, #0056b3);
        }

        .cancel-button:hover {
            background-color: var(--cancel-button-hover-bg-color, #e2e6ea);
        }
    `;
    }

    static get properties() {
        return {
            isOpen: { type: Boolean },
            closeOnClickOutside: { type: Boolean, attribute: 'close-on-click-outside' },
        };
    }

    constructor() {
        super();
        this.isShow = false;
        this.closeOnClickOutside = true;
    }

    show() {
        this.isShow = true;
        this.requestUpdate();

        // // モーダルが表示された後に解決されるPromiseを返す
        // return new Promise((resolve) => {
        //     // visibilityとopacityのトランジションが完了した後にresolve()を呼び出す
        //     this.shadowRoot.querySelector('.modal-backdrop').addEventListener('transitionend', () => {
        //         resolve();
        //     }, { once: true }); // イベントは一度だけ処理
        // });

        // モーダルが表示された後に解決されるPromiseを返す
        return new Promise((resolve) => {
            requestAnimationFrame(() => { // DOM更新後に実行
                // visibilityとopacityのトランジションが完了した後にresolve()を呼び出す
                const modalBackdrop = this.shadowRoot.querySelector('.modal-backdrop');
                if (modalBackdrop) {
                    modalBackdrop.addEventListener('transitionend', () => {
                        resolve();
                    }, { once: true }); // イベントは一度だけ処理
                } else {
                    // .modal-backdrop が見つからない場合のエラー処理
                    console.error('.modal-backdrop element not found!');
                    resolve(); // またはreject()でエラーを返す
                }
            });
        });
    }

    hide() {
        this.isShow = false;
        this.requestUpdate();
    }

    handleCancel(event) {
        event.preventDefault();
        // カスタムイベントを発火して、親コンポーネントに通知します
        this.dispatchEvent(new CustomEvent('modal-cancel', {
            detail: { dialogName: this.shadowRoot.host.id },
            bubbles: true,
            composed: true,
        }));
        this.hide();
    }

    handleSubmit(event) {
        event.preventDefault();

        // カスタムイベントを発火して、親コンポーネントに通知します
        this.dispatchEvent(new CustomEvent('modal-submit', {
            detail: { formData: new FormData(event.target), dialogName: this.shadowRoot.host.id },
            bubbles: true,
            composed: true,
        }));
    }

    render() {
        // 外部クリックで閉じる場合のみイベントリスナーを追加
        const backdropClickHandler = this.closeOnClickOutside ? this.hide : () => { };

        return html`
      <div class="modal-backdrop ${this.isShow ? 'active' : ''}" @click="${backdropClickHandler}">
        <div class="modal" @click=${e => e.stopPropagation()}>
          <div class="modal-header">
            <h2><slot name="header-title">デフォルトタイトル</slot></h2>
            <!--<span class="close-button" @click=${this.hide}>&times;</span>-->
          </div>
          <div class="modal-body">
            <form @submit=${this.handleSubmit}>
              <!-- 外部からのスロットを挿入 -->
              <slot name="content"></slot>
              <div class="form-actions">
                <button type="submit" class="submit-button"><slot name="submit-button-text">保存</slot></button>
                <button type="button" class="cancel-button" @click=${this.handleCancel}><slot name="cancel-button-text">キャンセル</slot></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    `;
    }
}

customElements.define('dashboard-modal-window', DashboardModalWindow);
